module.exports = __webpack_public_path__ + "25e968e2d9666fff675cfb6dbba83430.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icn-sony-200.png
// module id = 1540
// module chunks = 0